import { Component, OnInit, Inject, ComponentRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'telio-general-dialog',
  templateUrl: './general-dialog.component.html',
  styleUrls: ['./general-dialog.component.scss']
})
export class GeneralDialogComponent implements OnInit {

  portal: ComponentPortal<any>;
  reference: ComponentRef<any>;
  formGroup: any;
  disabled: boolean;
  constructor(
    public dialogRef: MatDialogRef<GeneralDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.portal = new ComponentPortal(this.data.component);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onComponentRendering(ref) {
    this.reference = ref as ComponentRef<any>;
    if (this.data.value && ref && ref.instance && ref.instance.options) {
      ref.instance.options.value = this.data.value;
    }
    if (this.reference && this.reference.instance && this.reference.instance.options) {
      this.formGroup = this.reference.instance.options;
      this.formGroup.statusChanges.subscribe(x => {
        if (this.formGroup.status != 'VALID')
          this.disabled = true;
        else if (this.formGroup.status == 'VALID')
          this.disabled = false;
      })
    }
    if(this.reference && this.reference.instance && this.reference.instance.pageDetails)
    {
      this.reference.instance.pageDetails = this.data.value;
    }
  }

  buttonClick(): void {
    if (this.reference && this.reference.instance && this.reference.instance.options) {
      let formgroup = this.reference.instance.options;
      if (formgroup && formgroup.status == 'VALID')
        this.dialogRef.close(formgroup);
      else
        return;
    }
    else if (this.reference.componentType.name == 'ConfirmDialogComponent') {
      this.dialogRef.close('Yes');
    }
  }
}
